export const MAXIMUM_DEVICE_SETTING_SETS = 5;
